import React from 'react';
import {
    Create,
    SimpleForm,
    FileInput,
    FileField,
    Toolbar,
    SaveButton,
    TextInput,
} from 'react-admin';
import jwt_decode from 'jwt-decode';
let branch_code =  (localStorage && localStorage.token)? (jwt_decode(localStorage.token)? jwt_decode(localStorage.token).branch_code : ''): '';

const UploadCreateToolbar = props => (
    <Toolbar {...props} >
        <SaveButton
            label="Upload"
            submitOnEnter={true}
            redirect="/donors"
        />
    </Toolbar>
);

const UploadCreate = ({...props }) => (
    <Create  title='CSV File uploads'   {...props}>
        <SimpleForm   toolbar={<UploadCreateToolbar />} >
        <FileInput source="payment" label="Payment upload" accept=".csv">
            <FileField source="src" title="Payment" />
        </FileInput>
        <FileInput source="lab" label="Lab Test Results upload" accept=".csv">
            <FileField source="src" title="Test Results" />
        </FileInput>
        <TextInput source='branch_code' label = '' defaultValue={branch_code} style={{visibility: "hidden"}} />
        </SimpleForm>
    </Create>
)

export default UploadCreate;